import React from 'react'
import { Heading, PageContent, PageFooter, Button, CircularProgressBar } from '@brainstud/react-tbl/themes/pgw/v1/components/library'

const PageIntro = props => (
  <PageContent>
    <Heading h1>{props.title}</Heading>
    <Heading em html>{props.description}</Heading>

    {props.children}

    <PageFooter>
      <div className="Page-footer-left">
        <Button outline onClick={props.handleHome} icon="home" />
      </div>

      <div className="Page-footer-right">
        {props.progress &&
          <div style={{ marginRight: '2rem' }}>
            <CircularProgressBar
              label={`${props.progress.progress}/${props.progress.total}`}
              percentage={Math.floor(props.progress.progress/props.progress.total*100)}
              sqSize={50}
              strokeWidth={6} />
          </div>
        }

        <Button primary square fixed onClick={props.handleContinue} label={props.continueButtonLabel} style={{ padding: '0 3rem' }}/>
      </div>
    </PageFooter>
  </PageContent>
)

export default PageIntro
